package com.parmartechnologies.core.feature.business.model


import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.address.model.Address
import com.parmartechnologies.core.feature.address.model.LocationCoordinate
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class Business @OptIn(ExperimentalTime::class) constructor(
    @SerialName("business_number") var BusinessNumber: Long = 0,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_type_id") var BusinessTypeID: String = "",
    @SerialName("name") var Name: String = "",
    @SerialName("address") var Address: Address = Address(),
    @SerialName("note_one") var noteOne: String = "",
    @SerialName("note_two") var noteTwo: String = "",
    @SerialName("location") var Location: LocationCoordinate = LocationCoordinate(),
    @SerialName("dealer_name") var DealerName: String = "",
    @SerialName("product_types") var ProductTypes: ArrayList<String> = arrayListOf(),
    @SerialName("gst_number") var GSTNumber: String = "",
    @SerialName("pan_number") var panNumber: String = "",
    @SerialName("pan_verified") var panVerified: String = "",
    @SerialName("gst_verified") var gstVerified: String = "",
    @SerialName("business_verified") var businessVerified: String = "",
    @SerialName("status") var Status: String = "",
    @SerialName("email_id") var EmailID: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("country_code") var CountryCode: String = "",
    @SerialName("gender") var Gender: Long = 0,
    @SerialName("device_id") var DeviceID: String = "",
    @SerialName("fcm_token") var FCMToken: String = "",
    @SerialName("last_seen") var LastSeen: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("is_primary") var IsPrimary: Int = 0,
) : BaseDataClass()